module.exports = __webpack_public_path__ + "img/frame (279).a0028736.jpg";